import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const PublicRoute = (props) => {
    const token = localStorage.getItem('token');
    return !token ? <Route {...props} /> : <Redirect to="/driver/assignments" />;
};

export default PublicRoute;
